export const OrderHistoryPages = {
  ORDER_DETAIL: "ORDER_DETAIL",
  MY_ORDERS: "MY_ORDERS",
  PREVIOUS_ORDERS_DETAIL: "PREVIOUS_ORDERS_DETAIL",
  ADVANCED_ORDER_DETAIL: "ADVANCED_ORDER_DETAIL",

};
